module.exports = __webpack_public_path__ + "static/DK_LNSG_Website-165ec459cbdbd4096ca472fd5a4eea41.jpg";